<template>
  <div>
    <div class="d-flex justify-content-between align-items-center mb-32">
      <h3 class="m-0">Документы для загрузки</h3>
    </div>
    <!-- HITECH: направление на обучение от работодателя (письмо МЭЦ) хранится в scan_trip_education -->
    <template v-if="isHitech">
      <base-upload :required="true" id="scan_trip_education" name="scan_trip_education" title="Направление на обучение от работодателя (письмо МЭЦ)"
                   description="<span class='text-red'>Для оформления заявки приложите направление на обучение от работодателя (письмо МЭЦ), оформленное на бланке организации, с подписью руководителя и печатью организации</span>"
                   v-model="docs.scan_trip_education" :accept="hitechTripEducationAccept" :notify-on-error="true" />
      <!-- Образец письма МЭЦ не добавлен: существующий образец адресован «Школе экспорта», нужен образец от заказчика -->
    </template>
    <template v-else-if="!hideDirectionScan">
      <base-upload :required="true" id="scan_trip_education" name="scan_trip_education" title="Направление на обучение в АНО ДПО «Школа экспорта АО «Российский экспортный центр»"
                   description="<span class='text-red'>Для оформления заявки на дистанционное обучение необходимо подготовить и приложить направление на обучение, оформленное на бланке Вашей организации (с печатью организации и подписью руководителя). Образец направления на обучение можно скачать ниже</span>"
                   v-model="docs.scan_trip_education" :sample="{title: 'Образец направления на обучение', link: 'https://exporteduru.servicecdn.ru/media/attachment/0002/55/2f8595a322ebeda240ccf01fbf3f040d2abcfb5d.docx'}" />
    </template>
    <template v-if="hasFull">
      <base-upload :required="true" id="scan_passport" name="scan_passport" title="Скан паспорта" v-model="docs.scan_passport" :notify-on-error="isHitech"/>
      <template v-if="programId === 56">
        <base-upload v-if="hasHigherEducation" :required="true" id="scan_diploma" name="scan_diploma" :title="getDiplomaTitle()" v-model="docs.scan_diploma"/>
        <base-upload :required="true" id="scan_trip_education" name="scan_trip_education" :title="getForwardTitle('student')" v-model="docs.scan_trip_education"/>
      </template>
      <template v-else>
        <base-upload :required="true" id="scan_diploma" name="scan_diploma" :title="getDiplomaTitle()" v-model="docs.scan_diploma" :notify-on-error="isHitech"/>
      </template>
      <base-upload :required="true" id="scan_snils" name="scan_snils" title="Скан СНИЛС" v-model="docs.scan_snils" :notify-on-error="isHitech"/>
    </template>
    <template v-if="programId === 57">
      <base-upload :required="true" id="scan_trip_education" name="scan_trip_education" :title="getForwardTitle('teacher')" v-model="docs.scan_trip_education" />
    </template>
    <base-upload :required="false" id="scan_change_surname" name="scan_change_surname" title="Свидетельство о смене фамилии" description="Копия свидетельства о смене фамилии (при необходимости)" v-model="docs.scan_change_surname" :notify-on-error="isHitech" />
  </div>
</template>

<script>
import BaseUpload from "@/components/form/BaseUpload.vue";
import ApiService from "../../services/api.service";
import tippy from "tippy.js";
import {isHitechProgram} from "@/data/programs";

// HITECH: письмо МЭЦ от работодателя может прийти в Word, поэтому к стандартным форматам BaseUpload добавлен .docx
const HITECH_TRIP_EDUCATION_ACCEPT = 'application/msword, application/vnd.openxmlformats-officedocument.wordprocessingml.document, .docx, text/plain, application/pdf, image/png, image/jpg, image/jpeg'

export default {
  name: "OnlineOrderDocs",
  components: {BaseUpload},
  props: ['value', 'hasFull', 'hideDirectionScan', 'programId', 'hasHigherEducation'],
  computed: {
    // Программа ПК «Экспорт высокотехнологичной продукции»
    isHitech() {
      return isHitechProgram(this.programId)
    }
  },
  async mounted() {
    const params = this.programId ? { params: { program: this.programId } } : {}
    this.docs = (await ApiService.get('userdoc/extramural', params)).data
    this.firstLoad = false
    
    // Инициализация tooltip для студентов
    if(this.programId === 56 && !this.hasHigherEducation) {
      this.$nextTick(() => {
        setTimeout(() => {
          const element = document.getElementById(`tooltip-forward-student-${this._uid}`)
          if(element) {
            tippy(element, {
              content: this.getStudentTooltipContent(),
              allowHTML: true,
              placement: 'top',
              arrow: true,
              maxWidth: 800,
              theme: 'horizontal-tooltip'
            });
          }
        }, 100)
      });
    }
    
    // Инициализация tooltip для преподавателей
    if(this.programId === 57) {
      this.$nextTick(() => {
        setTimeout(() => {
          const element = document.getElementById(`tooltip-forward-teacher-${this._uid}`)
          if(element) {
            tippy(element, {
              content: this.getTeacherTooltipContent(),
              allowHTML: true,
              placement: 'top',
              arrow: true,
              maxWidth: 800,
              theme: 'horizontal-tooltip'
            });
          }
        }, 100)
      });
    }
  },
  methods: {
    getMedia(val, field) {
      return val[field] ? val[field].id : null
    },
    getDiplomaTitle() {
      return 'Скан диплома о высшем образовании'
    },
    getForwardTitle(type) {
      const tooltipId = type === 'student' 
        ? `tooltip-forward-student-${this._uid}`
        : `tooltip-forward-teacher-${this._uid}`
      
      if(type === 'student') {
        return `<span>Скан справки с места учебы</span> <img id="${tooltipId}" src="/pic/icon-black-question.svg" />`
      } else {
        return `<span>Справка с места работы</span> <img id="${tooltipId}" src="/pic/icon-black-question.svg" />`
      }
    },
    getStudentTooltipContent() {
      return '<div style="line-height: 1.5;">' +
        '<div style="margin-bottom: 12px;">Справка об обучении по программе бакалавриата, специалитета или магистратуры по одному или нескольким направлениям подготовки:</div>' +
        '<ul style="margin: 0; padding-left: 20px;">' +
        '<li>экономика (38.03.01/38.04.01)</li>' +
        '<li>менеджмент (38.03.02/38.04.02)</li>' +
        '<li>таможенное дело (38.05.02)</li>' +
        '<li>юриспруденция (40.03.01/40.04.01)</li>' +
        '<li>зарубежное регионоведение (41.03.01/41.04.01)</li>' +
        '<li>международные отношения (41.03.05/41.04.05)</li>' +
        '<li>востоковедение и африканистика (58.03.01)</li>' +
        '<li>перевод и переводоведение (45.05.01)</li>' +
        '<li>туризм (43.03.02/43.04.02)</li>' +
        '<li>гостиничное дело (43.03.03/43.04.03)</li>' +
        '</ul></div>'
    },
    getTeacherTooltipContent() {
      return '<div style="line-height: 1.5;">' +
        '<div style="margin-bottom: 12px;"> Справка об осуществлении преподавательской деятельности на условиях трудового договора на должностях: декан факультета, начальник факультета, директор института, начальник института, доцент, заведующий кафедрой, начальник кафедры, заместитель начальника кафедры, профессор, преподаватель, старший преподаватель по программам бакалавриата, специалитета или магистратуры по одному или нескольким направлениям подготовки:</div>' +
        '<ul style="margin: 0; padding-left: 20px;">' +
        '<li>экономика (38.03.01/38.04.01)</li>' +
        '<li>менеджмент (38.03.02/38.04.02)</li>' +
        '<li>таможенное дело (38.05.02)</li>' +
        '<li>юриспруденция (40.03.01/40.04.01)</li>' +
        '<li>зарубежное регионоведение (41.03.01/41.04.01)</li>' +
        '<li>международные отношения (41.03.05/41.04.05)</li>' +
        '<li>востоковедение и африканистика (58.03.01)</li>' +
        '<li>перевод и переводоведение (45.05.01)</li>' +
        '<li>туризм (43.03.02/43.04.02)</li>' +
        '<li>гостиничное дело (43.03.03/43.04.03)</li>' +
        '</ul></div>'
    }
  },
  data() {
    return {
      hitechTripEducationAccept: HITECH_TRIP_EDUCATION_ACCEPT,
      firstLoad: true,
      docs: {
        scan_trip_education: null
      }
    }
  },
  watch: {
    docs: {
      handler: function(val) {
        if(val.id && !this.firstLoad) {
          this.$emit('input', val)
          ApiService.put('userdocs/' + val.id, {
            scan_trip_education: this.getMedia(val, 'scan_trip_education'),
            scan_passport: this.getMedia(val, 'scan_passport'),
            scan_diploma: this.getMedia(val, 'scan_diploma'),
            scan_snils: this.getMedia(val, 'scan_snils'),
            scan_change_surname: this.getMedia(val, 'scan_change_surname'),
          })
        }
      },
      deep: true,
      immediate: true
    }
  }
}
</script>

<style lang="scss">
@import "./src/assets/style/variables";
.docs-needed {
  color: $blue-03;
  text-decoration: underline;
  position: relative;
  padding-right: 3.4rem;
  &:hover {
    text-decoration: none;
  }
  &:after {
    display: block;
    width: 2.4rem;
    height: 2.4rem;
    position: absolute;
    right: 0;
    content: "";
    top: 0;
    background: url("/pic/profile/arrow-up-right.svg");
  }
}
.tippy-box[data-theme~='horizontal-tooltip'] {
  max-width: 500px !important;
  width: auto !important;
}
</style>